function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { useState, useRef, useEffect } from 'react';
import { readFileAsText, addFileToTree } from '@edusense/shared-utils';
// --- 타입 정의 끝 ---
// Helper function to promisify FileSystemFileEntry.file()
var getFileFromFileEntry = function(fileEntry) {
    return new Promise(function(resolve, reject) {
        fileEntry.file(resolve, reject);
    });
};
/**
 * 폴더 업로드 기능을 위한 커스텀 훅
 */ export var useFileUpload = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var onUploadSuccess = options.onUploadSuccess;
    var _useState = _sliced_to_array(useState(null), 2), fileTree = _useState[0], setFileTree = _useState[1];
    var _useState1 = _sliced_to_array(useState([]), 2), projectFiles = _useState1[0], setProjectFiles = _useState1[1]; // 타입 변경
    var folderInputRef = useRef(null);
    var _useState2 = _sliced_to_array(useState(false), 2), isUploading = _useState2[0], setIsUploading = _useState2[1];
    var _useState3 = _sliced_to_array(useState(0), 2), uploadProgress = _useState3[0], setUploadProgress = _useState3[1];
    var _useState4 = _sliced_to_array(useState(null), 2), uploadError = _useState4[0], setUploadError = _useState4[1];
    /**
   * 폴더 선택 dialog 열기
   */ var triggerFolderUpload = function() {
        console.log('[triggerFolderUpload] Attempting to trigger folder upload.');
        if (folderInputRef.current) {
            console.log('[triggerFolderUpload] Input element found.', {
                disabled: folderInputRef.current.disabled,
                value: folderInputRef.current.value
            });
            folderInputRef.current.click();
            console.log('[triggerFolderUpload] Input element clicked.');
        } else {
            console.log('[triggerFolderUpload] Input element ref is null!');
        }
    };
    /**
   * 디렉토리 항목을 재귀적으로 읽어 파일 목록 반환 (Promise.all 사용 개선)
   * node_modules 폴더는 건너뛴다.
   */ var readDirectoryEntries = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(entry) {
            var entryPath, reader, allEntries, files, processingPromises, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _loop, _iterator, _step;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        entryPath = entry.fullPath.substring(1);
                        console.log("[readDirectoryEntries] Reading directory: ".concat(entry.fullPath));
                        if (entryPath.startsWith('node_modules') || entryPath.includes('/node_modules')) {
                            console.log("[readDirectoryEntries] Skipping node_modules directory: ".concat(entryPath));
                            return [
                                2,
                                []
                            ];
                        }
                        reader = entry.createReader();
                        allEntries = [];
                        // readEntries는 한 번에 모든 항목을 반환하지 않을 수 있으므로, 완료될 때까지 반복 호출
                        return [
                            4,
                            new Promise(function(resolve, reject) {
                                var readBatch = function() {
                                    reader.readEntries(function(batchEntries) {
                                        if (batchEntries.length > 0) {
                                            allEntries = allEntries.concat(batchEntries);
                                            readBatch(); // 다음 배치 읽기
                                        } else {
                                            resolve(); // 더 이상 항목 없음
                                        }
                                    }, reject); // 읽기 오류 시 reject
                                };
                                readBatch();
                            })
                        ];
                    case 1:
                        _state.sent();
                        console.log("[readDirectoryEntries] All entries found in ".concat(entry.name, ":"), allEntries.map(function(e) {
                            return e.name;
                        }));
                        files = [];
                        processingPromises = []; // 비동기 작업을 위한 Promise 배열
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            _loop = function() {
                                var subEntry = _step.value;
                                console.log("[readDirectoryEntries] Processing entry: ".concat(subEntry.fullPath));
                                var subEntryPath = subEntry.fullPath.substring(1);
                                if (subEntryPath.startsWith('node_modules') || subEntryPath.includes('/node_modules')) {
                                    console.log("[readDirectoryEntries] Skipping node_modules entry: ".concat(subEntryPath));
                                    return "continue";
                                }
                                if (subEntry.isFile) {
                                    var fileEntry = subEntry;
                                    // 파일 읽기 Promise 생성 및 배열에 추가
                                    var filePromise = getFileFromFileEntry(fileEntry).then(function(file) {
                                        var relativePath = fileEntry.fullPath.substring(1);
                                        files.push({
                                            file: file,
                                            relativePath: relativePath
                                        });
                                        console.log("[readDirectoryEntries] Added file: ".concat(relativePath));
                                    }).catch(function(error) {
                                        console.error("[readDirectoryEntries] Error reading file ".concat(fileEntry.fullPath, ":"), error);
                                    // 오류 발생 시 해당 파일 건너뛰기 또는 전체 중단 처리 가능
                                    });
                                    processingPromises.push(filePromise);
                                } else if (subEntry.isDirectory) {
                                    console.log("[readDirectoryEntries] Entering subdirectory: ".concat(subEntry.fullPath));
                                    var dirEntry = subEntry;
                                    // 재귀 호출 Promise 생성 및 배열에 추가
                                    var subDirPromise = readDirectoryEntries(dirEntry) // 재귀 호출
                                    .then(function(subFiles) {
                                        var _files;
                                        (_files = files).push.apply(_files, _to_consumable_array(subFiles)); // 하위 폴더에서 읽어온 파일들 추가
                                    }).catch(function(error) {
                                        console.error("[readDirectoryEntries] Error reading subdirectory ".concat(dirEntry.fullPath, ":"), error);
                                    // 하위 폴더 오류 처리
                                    });
                                    processingPromises.push(subDirPromise);
                                }
                            };
                            for(_iterator = allEntries[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        // 현재 디렉토리 내의 모든 파일 읽기 및 하위 디렉토리 탐색이 완료될 때까지 대기
                        return [
                            4,
                            Promise.all(processingPromises)
                        ];
                    case 2:
                        _state.sent();
                        console.log("[readDirectoryEntries] Finished processing directory: ".concat(entry.fullPath, ", collected ").concat(files.length, " files from this branch."));
                        return [
                            2,
                            files
                        ]; // 이 디렉토리 레벨에서 수집된 모든 파일 반환
                }
            });
        });
        return function readDirectoryEntries(entry) {
            return _ref.apply(this, arguments);
        };
    }();
    /**
   * 드롭된 폴더를 처리하는 함수
   */ var handleDropFolder = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(items) {
            var entries, i, item, rootEntry, fileList, error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!items) return [
                            2
                        ];
                        setIsUploading(true);
                        setUploadProgress(0);
                        setUploadError(null);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        entries = [];
                        for(i = 0; i < items.length; i++){
                            item = items[i].webkitGetAsEntry();
                            if (item === null || item === void 0 ? void 0 : item.isDirectory) {
                                entries.push(item);
                            } else if (item === null || item === void 0 ? void 0 : item.isFile) {
                                console.log('단일 파일 드롭은 지원하지 않습니다.');
                            }
                        }
                        if (entries.length === 0) {
                            setUploadError('드롭된 항목 중 폴더가 없습니다.');
                            setIsUploading(false);
                            return [
                                2
                            ];
                        }
                        rootEntry = entries[0]; // 첫 번째 드롭된 폴더만 처리 가정
                        console.log('처리할 루트 디렉토리 항목:', rootEntry.name);
                        return [
                            4,
                            readDirectoryEntries(rootEntry)
                        ];
                    case 2:
                        fileList = _state.sent();
                        if (fileList.length === 0) {
                            setUploadError('폴더 내에 node_modules를 제외한 유효한 파일이 없습니다.');
                            setIsUploading(false);
                            return [
                                2
                            ];
                        }
                        // 파일 처리 및 FileSystemTree 생성
                        return [
                            4,
                            processFilesAndCreateTree(fileList, rootEntry.name)
                        ];
                    case 3:
                        _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 4:
                        error = _state.sent();
                        console.error('드롭된 폴더 처리 중 오류 발생:', error);
                        setUploadError('드롭된 폴더 처리 중 오류가 발생했습니다.');
                        setIsUploading(false); // 오류 발생 시 상태 초기화
                        return [
                            3,
                            5
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleDropFolder(items) {
            return _ref.apply(this, arguments);
        };
    }();
    /**
   * 파일 목록을 처리하여 FileSystemTree를 생성하고 상태 업데이트
   * (이제 node_modules가 필터링된 파일 목록을 받는다고 가정)
   */ var processFilesAndCreateTree = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(files, rootName) {
            var MAX_TOTAL_SIZE_MB, MAX_FILES, totalSizeMB, newFileTree, totalFiles, processedFiles, hasPackageJson, MAX_SINGLE_FILE_SIZE_MB, skippedFiles, BATCH_SIZE, i, batch, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _step_value, file, relativePath, filePath, pathParts, fileSizeMB, isBinary, fileNode, current, actualPathParts, j, part, node, contents, error, err, error1;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        // 함수 시작 시 필터링은 제거 (상위에서 이미 수행됨)
                        // const files = allFiles.filter(...); 
                        // 이제 'files'는 이미 필터링된 목록임
                        if (files.length === 0) {
                            setUploadError('node_modules 폴더를 제외한 유효한 파일이 없습니다.');
                            setIsUploading(false);
                            return [
                                2
                            ];
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            18,
                            19,
                            20
                        ]);
                        // 파일 크기 및 개수 제한 확인 (필터링된 'files' 배열 사용)
                        MAX_TOTAL_SIZE_MB = 50;
                        MAX_FILES = 500;
                        if (files.length > MAX_FILES) {
                            setUploadError("파일 개수(".concat(files.length, "개)가 너무 많습니다. 최대 ").concat(MAX_FILES, "개까지 가능합니다."));
                            setIsUploading(false);
                            return [
                                2
                            ];
                        }
                        totalSizeMB = files.reduce(function(sum, f) {
                            return sum + f.file.size;
                        }, 0) / (1024 * 1024);
                        if (totalSizeMB > MAX_TOTAL_SIZE_MB) {
                            setUploadError("총 파일 크기(".concat(totalSizeMB.toFixed(1), "MB)가 너무 큽니다. 최대 ").concat(MAX_TOTAL_SIZE_MB, "MB까지 가능합니다."));
                            setIsUploading(false);
                            return [
                                2
                            ];
                        }
                        // File 객체 목록 상태 업데이트 (이제 {file, relativePath} 구조 그대로 사용)
                        setProjectFiles(files); // files 배열은 이미 {file, relativePath} 형태임
                        // @ts-ignore
                        newFileTree = {};
                        totalFiles = files.length; // 필터링된 파일 개수 사용
                        processedFiles = 0;
                        hasPackageJson = false;
                        // package.json 파일 찾기 로직은 일단 제거 (필요시 복구)
                        console.log("처리할 파일 ".concat(totalFiles, "개 발견 (node_modules 제외됨), 루트: ").concat(rootName));
                        MAX_SINGLE_FILE_SIZE_MB = 10;
                        skippedFiles = [];
                        // 파일 처리 로직 (필터링된 'files' 배열 사용)
                        BATCH_SIZE = 50;
                        i = 0;
                        _state.label = 2;
                    case 2:
                        if (!(i < files.length)) return [
                            3,
                            17
                        ];
                        batch = files.slice(i, i + BATCH_SIZE);
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        _state.label = 3;
                    case 3:
                        _state.trys.push([
                            3,
                            12,
                            13,
                            14
                        ]);
                        _iterator = batch[Symbol.iterator]();
                        _state.label = 4;
                    case 4:
                        if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                            3,
                            11
                        ];
                        _step_value = _step.value, file = _step_value.file, relativePath = _step_value.relativePath;
                        filePath = relativePath || file.name;
                        pathParts = filePath.split('/');
                        fileSizeMB = file.size / (1024 * 1024);
                        if (fileSizeMB > MAX_SINGLE_FILE_SIZE_MB) {
                            console.warn("파일이 너무 큽니다: ".concat(filePath, " (").concat(fileSizeMB.toFixed(2), "MB)"));
                            skippedFiles.push(filePath);
                            processedFiles++;
                            setUploadProgress(Math.round(processedFiles / totalFiles * 100));
                            return [
                                3,
                                10
                            ];
                        }
                        isBinary = /\.(jpg|jpeg|png|gif|mp4|webm|wav|mp3|pdf|zip|gz|tar|doc|docx|xls|xlsx|bin)$/i.test(filePath);
                        if (!isBinary) return [
                            3,
                            5
                        ];
                        fileNode = {
                            file: {
                                contents: "Binary file: ".concat(filePath, " (").concat((file.size / 1024).toFixed(2), " KB)")
                            }
                        };
                        current = newFileTree;
                        actualPathParts = pathParts.length > 1 ? pathParts.slice(1) : pathParts;
                        for(j = 0; j < actualPathParts.length - 1; j++){
                            part = actualPathParts[j];
                            if (!current[part]) {
                                current[part] = {
                                    directory: {}
                                };
                            }
                            node = current[part];
                            if ((typeof node === "undefined" ? "undefined" : _type_of(node)) === 'object' && node !== null && 'directory' in node) {
                                current = node.directory;
                            } else {
                                // 이론적으로 이 경우는 발생하면 안 됨 (위에서 directory를 생성하므로)
                                console.error("[useFileUpload] 예상치 못한 노드 타입 발견: ".concat(part), node);
                                throw new Error("Failed to traverse directory structure at ".concat(part));
                            }
                        }
                        if (actualPathParts.length > 0) {
                            current[actualPathParts[actualPathParts.length - 1]] = fileNode;
                        }
                        return [
                            3,
                            8
                        ];
                    case 5:
                        _state.trys.push([
                            5,
                            7,
                            ,
                            8
                        ]);
                        return [
                            4,
                            readFileAsText(file)
                        ];
                    case 6:
                        contents = _state.sent();
                        addFileToTree(newFileTree, pathParts, contents);
                        return [
                            3,
                            8
                        ];
                    case 7:
                        error = _state.sent();
                        console.error("파일 읽기 오류: ".concat(filePath), error);
                        skippedFiles.push(filePath);
                        return [
                            3,
                            8
                        ];
                    case 8:
                        processedFiles++;
                        setUploadProgress(Math.round(processedFiles / totalFiles * 100));
                        if (!(processedFiles % 10 === 0)) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            new Promise(function(resolve) {
                                return setTimeout(resolve, 1);
                            })
                        ];
                    case 9:
                        _state.sent();
                        _state.label = 10;
                    case 10:
                        _iteratorNormalCompletion = true;
                        return [
                            3,
                            4
                        ];
                    case 11:
                        return [
                            3,
                            14
                        ];
                    case 12:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            14
                        ];
                    case 13:
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                        return [
                            7
                        ];
                    case 14:
                        // 배치 사이 잠시 대기 (UI 렌더링 및 가비지 컬렉션 허용)
                        return [
                            4,
                            new Promise(function(resolve) {
                                return setTimeout(resolve, 5);
                            })
                        ];
                    case 15:
                        _state.sent();
                        _state.label = 16;
                    case 16:
                        i += BATCH_SIZE;
                        return [
                            3,
                            2
                        ];
                    case 17:
                        if (skippedFiles.length > 0) {
                            console.warn("".concat(skippedFiles.length, "개 파일을 처리하지 못했습니다 (크기 초과 또는 읽기 오류)."));
                        // 필요시 사용자에게 알림 추가 (예: setUploadError)
                        }
                        // package.json 생성 로직 확인 (필요 없을 수 있음, WebContainer가 처리 가정)
                        // if (!hasPackageJson && files.length > 0) {
                        //   console.log('package.json 파일이 없어 기본 파일을 생성합니다.');
                        //   newFileTree['package.json'] = createDefaultPackageJson();
                        // }
                        setFileTree(newFileTree);
                        console.log('[useFileUpload] FileSystemTree 생성 완료:', newFileTree);
                        setUploadError(null); // 성공 시 에러 초기화
                        // 성공 콜백 호출 시 필터링된 파일 목록 전달 ({file, relativePath} 구조 사용)
                        if (onUploadSuccess) {
                            onUploadSuccess(newFileTree, files);
                        }
                        return [
                            3,
                            20
                        ];
                    case 18:
                        error1 = _state.sent();
                        console.error('파일 처리 중 오류 발생:', error1);
                        setUploadError('파일 처리 중 오류가 발생했습니다.');
                        // 오류 발생 시 projectFiles, fileTree 상태 초기화 고려
                        setProjectFiles([]);
                        setFileTree(null);
                        return [
                            3,
                            20
                        ];
                    case 19:
                        setIsUploading(false);
                        setUploadProgress(100); // 완료 또는 오류 시 100% 설정
                        return [
                            7
                        ];
                    case 20:
                        return [
                            2
                        ];
                }
            });
        });
        return function processFilesAndCreateTree(files, rootName) {
            return _ref.apply(this, arguments);
        };
    }();
    /**
   * 폴더 업로드(클릭)를 처리하는 함수
   */ var handleFolderUpload = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(event) {
            var inputFiles, filesArray, filteredFiles, rootDirName, firstPath, parts;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        console.log('[handleFolderUpload] onChange event triggered.'); // 함수 시작 로그 추가
                        inputFiles = event.target.files;
                        if (!inputFiles || inputFiles.length === 0) {
                            console.log('[handleFolderUpload] No files selected or event cancelled.');
                            return [
                                2
                            ];
                        }
                        filesArray = Array.from(inputFiles);
                        setIsUploading(true);
                        setUploadProgress(0);
                        setUploadError(null);
                        console.log('[handleFolderUpload] Original input files:', filesArray.map(function(f) {
                            return {
                                name: f.name,
                                webkitRelativePath: f.webkitRelativePath
                            };
                        }));
                        // --- handleFolderUpload 내에서 node_modules 필터링 추가 ---
                        filteredFiles = filesArray.filter(function(file) {
                            var filePath = file.webkitRelativePath || file.name;
                            return typeof filePath === 'string' && !filePath.startsWith('node_modules/');
                        });
                        if (filesArray.length !== filteredFiles.length) {
                            console.log("[handleFolderUpload] node_modules 폴더 내 파일 ".concat(filesArray.length - filteredFiles.length, "개를 제외했습니다."));
                        }
                        if (filteredFiles.length === 0) {
                            setUploadError('선택된 폴더에 node_modules를 제외한 유효한 파일이 없습니다.');
                            setIsUploading(false);
                            if (event.target) event.target.value = '';
                            return [
                                2
                            ]; // 처리 중단
                        }
                        // --- 필터링 로직 끝 ---
                        rootDirName = '';
                        if (filteredFiles.length > 0) {
                            firstPath = filteredFiles[0].webkitRelativePath || filteredFiles[0].name;
                            parts = firstPath.split('/');
                            if (parts.length > 1) {
                                rootDirName = parts[0];
                            }
                        }
                        console.log("[handleFolderUpload] 루트 디렉토리 이름 감지: ".concat(rootDirName));
                        // 필터링된 파일 목록(filteredFiles)을 processFilesAndCreateTree로 전달
                        console.log('[handleFolderUpload] Files sent to processFilesAndCreateTree:', filteredFiles.map(function(f) {
                            return {
                                name: f.name,
                                relativePath: f.webkitRelativePath || f.name
                            };
                        }));
                        return [
                            4,
                            processFilesAndCreateTree(filteredFiles.map(function(f) {
                                return {
                                    file: f,
                                    relativePath: f.webkitRelativePath || f.name
                                };
                            }), rootDirName)
                        ];
                    case 1:
                        _state.sent();
                        if (event.target) {
                            console.log('[handleFolderUpload] Resetting input value.');
                            event.target.value = ''; // 함수 끝으로 이동
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function handleFolderUpload(event) {
            return _ref.apply(this, arguments);
        };
    }();
    // 디버깅용 useEffect 추가 (projectFiles 상태 확인, 구조 반영)
    useEffect(function() {
        console.log('[useFileUpload] projectFiles 상태 변경:', projectFiles.map(function(f) {
            return {
                name: f.file.name,
                path: f.relativePath
            };
        }));
    }, [
        projectFiles
    ]);
    return {
        fileTree: fileTree,
        setFileTree: setFileTree,
        projectFiles: projectFiles,
        setProjectFiles: setProjectFiles,
        isUploading: isUploading,
        uploadProgress: uploadProgress,
        uploadError: uploadError,
        setUploadError: setUploadError,
        triggerFolderUpload: triggerFolderUpload,
        handleFolderUpload: handleFolderUpload,
        folderInputRef: folderInputRef,
        handleDropFolder: handleDropFolder
    };
};
